import { useNavigate } from "react-router-dom"
import { useMemo } from "react"

import {
    createdBookingLoader,
    createdDepositLoader,
    createdTimeRequestLoader,
} from "../BookingCommon/common/queries"

import { PageHeader } from "components/Header/PageHeader"
import { Pages } from "modules/BookingCommon/common/constants"
import { useFromLink } from "utils/hooks"
import { useBookingContext } from "modules/Booking/BookingContext"
import { useGetCurrentPage } from "modules/Booking/common/hooks/useGetCurrentPage"

export function Header() {
    const fromLink = useFromLink()
    const navigate = useNavigate()
    const [{ indexOfCurrentPage, pagesCount, psy }] = useBookingContext()

    const currentPage = useGetCurrentPage()
    const bookingHash = createdBookingLoader.getHash()
    const timeRequestHash = createdTimeRequestLoader.getHash()
    const depositHash = createdDepositLoader.getHash()

    const stepsPages = useMemo(() => {
        const pages = [Pages.CARDS, Pages.SESSION_DATE, Pages.FORM]

        if (currentPage && !pages.includes(currentPage)) {
            pages.push(currentPage)
        }

        return pages
    }, [currentPage])

    const showStepsCounter =
        (!bookingHash || !timeRequestHash || !depositHash) &&
        currentPage &&
        currentPage !== Pages.PAYMENT
            ? stepsPages.includes(currentPage)
            : false

    const prevPage =
        indexOfCurrentPage > 0
            ? () => navigate(-1)
            : () => {
                  if (fromLink) {
                      navigate(fromLink)
                      return
                  }
                  navigate(psy.profile_url, {
                      replace: true,
                  })
              }

    return (
        <PageHeader
            step={
                showStepsCounter
                    ? {
                          current: indexOfCurrentPage,
                          total: pagesCount,
                          previous: prevPage,
                      }
                    : undefined
            }
        />
    )
}
